import { usePostOrderInspectionApi, usePutOrderInspectionApi } from 'api/order_inspection'
import { Flex } from 'components/shared/flex'
import { InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { OrderInspection, OrderInspectionForm } from 'entities/order_inspection'
import { NestedModal } from 'components/shared/widget'

const FormView = (form: Form<OrderInspectionForm>, apiError: ApiError) => {
    return (
        <>
            <Flex>
                <InputField form={form} attr="rackCode" label="Rack ID" apiError={apiError} />
            </Flex>
        </>
    )
}

type NewOrderInspectionFormProps = {
    onComplete?: () => void
    orderId?: number
}

export const NewOrderInspectionForm = (props: NewOrderInspectionFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostOrderInspectionApi()
    const form = useForm<OrderInspectionForm>({ orderId: props.orderId })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        if (!form.object.orderId) {
            form.updateObject('orderId', props.orderId)
        }
    }, [form.object])

    useEffectSkipFirst(() => {
        form.updateObject('orderId', props.orderId)
    }, [props.orderId])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
                size="sm"
            >
                新規登録
            </Button>
            <NestedModal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>納品情報の登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>{FormView(form, api.apiError)}</>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </NestedModal>
        </>
    )
}

type EditOrderInspectionFormProps = {
    orderInspection: OrderInspection
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditOrderInspectionForm = (props: EditOrderInspectionFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutOrderInspectionApi()
    const form = useForm<OrderInspectionForm>({ ...props.orderInspection })

    useEffectSkipFirst(() => {
        form.set(props.orderInspection)
    }, [props.orderInspection])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <NestedModal show={props.show} onHide={props.onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>納品情報の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {form.object.id && (
                    <>
                        <h3 style={{ marginBottom: 10 }}>ID: {props.orderInspection.id}</h3>
                        {FormView(form, api.apiError)}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </NestedModal>
    )
}
